<template>
  <p class="text-gray-600 mx-8 mb-6">
    Designed and built by
    <a href="https://twitter.com/melvinsalas" target="_blank"
      ><b>👷🏻‍♂Melvin Salas</b></a
    >
    -
    <a href="https://www.ucenfotec.ac.cr/" target="_blank"
      >Universidad Cenfotec</a
    >
    (2020)
  </p>
</template>

<script>
export default {}
</script>

<style></style>
